import { Component, OnInit } from '@angular/core';
// import { Observable } from 'rxjs/Rx';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { CustomerService } from '../../../POSServices/Customers/customer.service';
import { CommonFunctionService, UserPOSData} from '../../../../services/Common/common-function.service';
import { UserMerchantData } from '../../../../services/Common/common-function.service';
@Component({
  selector: 'app-transactionviewdetails',
  templateUrl: './transactionviewdetails.component.html',
  styleUrls: ['./transactionviewdetails.component.scss']
})
export class TransactionviewdetailsComponent implements OnInit {
  currency:any;
  CustomerFirstName : string;
           CustomerLastName : string;
           CustomerAddress : string;
           CustomerCity : string;
           CustomerState : string;
           CustomerZipCode : string;
           CustomerEmailOne : string;
           CustomerContactNo : string;


  rFeeCode : string ;
  rFeeAmount : number;  
  rGstPercentage : number; 
  rGstAmount: number;  
  rTotalFeeAmount : number; 
  
  approve: boolean = false;
  decline: boolean = false;
  submit: boolean = false;
  PlatformId: any;
  Source: any;
  BatchId: any;
  sampleCustomerEmail: any;
  Id: any;
  RText: any;
  RCode: any
  ACode: any
  AccountFirst6: any
  AccountLast4: any
  Batch: any;
  viewid: number;
  CardNo;
  TransactionStatus;
  email;

  TransactionId: any;           //PaymentTransaction values
  MerchantKeyId: any;
  RequestUniqueId: any;
  MerchantNo: any;
  TerminalNo: any;
  CurrencyCode: any;
  IndustrySpecicationCode: any;
  RefTransactionId: any;
  AuthorizedAmount: any;
  TransactionAmount: any;
  SurchargeAmount: any;
  ResponseCode: any;
  ReasonCode: any;
  ApprovalCode: any;
  First6Digit: any;
  Last4Digit: any;
  TransactionReferenceNo: any;
  UpdatedDatetime: any;
  TransactionType: any;
  PaymentType: any;
  TransactionDateTime: any;
  BatchNo: any;
  BatchDateTime: any;
  Status: any;
  SystemTraceNo: any;
  AccountNoHash: any;
  ResponseText: any;
  ApiUser_UserId: any;
  ApiUser_UserType: any;
  ApiUser_SystemDetail: any;
  ApiUser_DeviceId: any;
  ApiUser_RequestIpAddress: any;
  ApprovalNetwork: any;
  Encryption_EncryptionType: any;       //l2 values
  Encryption_EncryptionKey: any;
  Encryption_DeviceType: any;
  Level2_PoNo: any;
  Level2_TaxType: any;
  Level2_TaxAmount: any;
  Level2_DutyAmount: any;
  Level2_FreightAmount: any;
  CustomerId: any;
  CustomerNotes: any;
  InvoiceNo: any;
  CustomerEmail: any;
  EmailReceipt: any;
  InventoryTrackFlag: any;
  Signature: any;
  AdditionalData1: any;
  AdditionalData2: any;
  CustomerBill_Id: any;
  CustomerShip_Id: any;
  NameonCard: any;         //card values
  AccountNo: any;
  ExpiryDate: any;
  CvvResponseCode: any;
  AvsResponseCode: any;
  CardCodeResponseCode: any;
  CardLevelResultCode: any;
  CardType: any;
  TrackType: any;
  ProcessorTransactionNo: any;
  TraceNo: any;
  TransactionSqNo: any;
  EncryptionId: any;
  EncryptionSalt: any;

  BankName: any;    //nb values
  BankId: any;
  BankReferenceNo: any;
  SurCharge: any;

  UPIMid: any;                        //upis values
  Type: any;
  CustomerReferenceId: any;
  UPICustomerMobileNo: any;
  NpciUpiTrxnId: any;
  ReferenceId: any;
  MerchantTrxnReferenceId: any;

  StatusDescription: any;
  Amount: any;
  TransactionAuthDate: any;
  PayerVitualAddress: any;
  PayerAccountNo: any;
  PayerAccountName: any;
  PayerIfsc: any;
  PayeeVitualAddress: any;
  PayeeAccountNo: any;
  PayeeAccountName: any;
  PayeeIfsc: any;
  PayeeAdhaar: any;
  AdditionField1: any;
  AdditionField2: any;
  AdditionField3: any;
  AdditionField4: any;
  AdditionField5: any;
  AdditionField6: any;
  AdditionField7: any;
  AdditionField8: any;
  AdditionField9: any;
  AdditionField10: any;
  WalletType: any;          //wallets values
  Mid: any;
  CustomerMobileNo: any;




  isCardsTransactionDetails: boolean = false;
  isNbsTransactionDetails: boolean = false;
  isUPITransactionDetails: boolean = false;
  isWalletTransactionDetails: boolean = false;
  isACHTransactionDetails: boolean = false;
  isSurchargeDetails: boolean = false;
  isRefundAmount: boolean = false;
  isSubmitted: boolean = false;

  // Transactionlist: Observable<any>
 
  constructor( private commonfunction: CommonFunctionService, private route: Router, private activatedRoute: ActivatedRoute, private service: CustomerService,) { 
    this.activatedRoute.params.subscribe(params => {
    this.viewid = params['id'];
    this.PaymentType = params['paymentType'];
    this.BatchId = params['batchId'];
    if (this.BatchId == 'undefined')
      this.BatchId = 0
  });
  if (environment.clientsidelogflag == 0) {
    console.log('view Id', this.viewid);
  }
 const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
 this.currency = this.commonfunction.GetCurrencysymbol();
 // const merchantdata = this.commonfunction.getUserPOSData()
  this.MerchantKeyId = merchantdata.MerchantKeyId;

  // this.service.VieworderTransactionDetails(this.viewid, this.MerchantKeyId, this.BatchId, this.PaymentType).subscribe(result => {


  this.service.VieworderTransactionDetails(this.viewid, this.MerchantKeyId).subscribe(result => {
    this.CustomerFirstName = result.FirstName;
    this.CustomerLastName = result.LastName;
    this.CustomerAddress = result.Address;
    this.CustomerCity = result.City;
    this.CustomerState = result.State;
    this.CustomerZipCode= result.ZipCode;
    this.CustomerEmailOne = result.Email;
    this.CustomerContactNo = result.ContactNo;
this.rFeeCode = result.FeeCode;
      this.rFeeAmount = result.FeeAmount;
      this.rGstPercentage = result.GstPercentage;
      this.rGstAmount = result.GstAmount;
      this.rTotalFeeAmount = result.TotalFeeAmount;
    this.Source = result.Source;
    this.PlatformId = result.PlatformId;
    this.TransactionId = result.TransactionId;
    this.MerchantKeyId = result.MerchantKeyId;
    this.RequestUniqueId = result.RequestUniqueId;
    this.MerchantNo = result.MerchantNo;
    this.TerminalNo = result.TerminalNo;
    this.CurrencyCode = result.CurrencyCode;
    this.IndustrySpecicationCode = result.IndustrySpecicationCode;
    this.RefTransactionId = result.RefTransactionId;
    this.AuthorizedAmount = result.AuthorizedAmount;
    this.TransactionAmount = result.TransactionAmount;
    this.SurchargeAmount = result.SurchargeAmount;
    this.ResponseCode = result.ResponseCode;
    if (this.ResponseCode == 1) {
      this.approve = true;
      this.decline = false;
      this.submit = false;
    }
    else if (this.ResponseCode == 2) {
      this.decline = true;
      this.approve = false;
      this.submit = false;
    }
    else if (this.ResponseCode == 4) {
      this.submit = true

      this.decline = false;
      this.approve = false;
    }
    this.ReasonCode = result.ReasonCode;
    this.ApprovalCode = result.ApprovalCode;
    this.First6Digit = result.First6Digit;
    this.Last4Digit = result.Last4Digit;
    this.TransactionReferenceNo = result.TransactionReferenceNo;
    this.UpdatedDatetime = result.UpdatedDatetime;
    this.TransactionType = result.TransactionType;
    this.PaymentType = result.PaymentType;
    this.TransactionDateTime = result.TransactionDateTime;
    this.BatchNo = result.BatchNo;
    this.BatchDateTime = result.BatchDateTime;
    this.Status = result.Status;
    this.SystemTraceNo = result.SystemTraceNo;
    this.AccountNoHash = result.AccountNoHash;
    this.ResponseText = result.ResponseText;
    this.ApiUser_UserId = result.ApiUser_UserId;
    this.ApiUser_UserType = result.ApiUser_UserType;
    this.ApiUser_SystemDetail = result.ApiUser_SystemDetail;
    this.ApiUser_DeviceId = result.ApiUser_DeviceId;
    this.ApiUser_RequestIpAddress = result.ApiUser_RequestIpAddress;
    this.ApprovalNetwork = result.ApprovalNetwork;
    this.Encryption_EncryptionType = result.Encryption_EncryptionType;    //l2 values
    this.Encryption_EncryptionKey = result.Encryption_EncryptionKey;
    this.Encryption_DeviceType = result.Encryption_DeviceType;
    this.Level2_PoNo = result.Level2_PoNo;
    this.Level2_TaxType = result.Level2_TaxType;
    this.Level2_TaxAmount = result.Level2_TaxAmount;
    this.Level2_DutyAmount = result.Level2_DutyAmount;
    this.Level2_FreightAmount = result.Level2_FreightAmount;
    this.CustomerId = result.CustomerId;
    this.CustomerNotes = result.CustomerNotes;
    this.InvoiceNo = result.InvoiceNo;
    this.CustomerEmail = result.CustomerEmail;
    this.EmailReceipt = result.EmailReceipt;
    this.InventoryTrackFlag = result.InventoryTrackFlag;
    this.Signature = result.Signature;
    this.AdditionalData1 = result.AdditionalData1;
    this.AdditionalData2 = result.AdditionalData2;
    this.CustomerBill_Id = result.CustomerBill_Id;
    this.CustomerShip_Id = result.CustomerShip_Id;

    if (this.ResponseCode == 4) {
      this.isSubmitted = true;
    }

    if (this.SurchargeAmount > 0) {
      this.isSurchargeDetails = true;
    }
    if (this.BatchId > 0 && result.Status != 2) {
      this.isRefundAmount = true;
    }
    if (this.PaymentType == "NetBanking") {
      this.BankName = result.BankName;  //nb values
      this.BankId =  result.BankId;
      this.BankReferenceNo = result.BankReferenceNo;
      this.SurCharge = result.SurCharge;
      this.isCardsTransactionDetails = false;
      this.isNbsTransactionDetails = true;
      this.isUPITransactionDetails = false;
      this.isWalletTransactionDetails = false;
      this.isACHTransactionDetails = false;

    }
    else if (this.PaymentType == "Wallet") {
      this.WalletType = result.WalletType;        //wallets values
      this.Mid = result.Mid;
      this.CustomerMobileNo = result.CustomerMobileNo;
      this.First6Digit = result.WalletType;
      this.Last4Digit = result.CustomerMobileNo;
      this.isCardsTransactionDetails = false;
      this.isNbsTransactionDetails = false;
      this.isUPITransactionDetails = false;
      this.isWalletTransactionDetails = true;
      this.isACHTransactionDetails = false;


    }
    else if (this.PaymentType == "Upi") {
      this.UPIMid = result.Mid;                     //upis values
      this.Type = result.Type;
      this.CustomerReferenceId = result.CustomerReferenceId;
      this.UPICustomerMobileNo = result.CustomerMobileNo;
      this.NpciUpiTrxnId = result.NpciUpiTrxnId;
      this.ReferenceId = result.ReferenceId;
      this.MerchantTrxnReferenceId = result.MerchantTrxnReferenceId;

      this.StatusDescription = result.StatusDescription;
      this.Amount = result.Amount;
      this.TransactionAuthDate = result.TransactionAuthDate;
      this.PayerVitualAddress = result.PayerVitualAddress;
      this.PayerAccountNo = result.PayerAccountNo;
      this.PayerAccountName = result.PayerAccountName;
      this.PayerIfsc = result.PayerIfsc;
      this.PayeeVitualAddress = result.PayeeVitualAddress;
      this.PayeeAccountNo = result.PayeeAccountNo;
      this.PayeeAccountName = result.PayeeAccountName;
      this.PayeeIfsc = result.PayeeIfsc;
      this.PayeeAdhaar = result.PayeeAdhaar;
      this.AdditionField1 = result.AdditionField1;
      this.AdditionField2 = result.AdditionField2;
      this.AdditionField3 = result.AdditionField3;
      this.AdditionField4 = result.AdditionField4;
      this.AdditionField5 = result.AdditionField5;
      this.AdditionField6 = result.AdditionField6;
      this.AdditionField7 = result.AdditionField7;
      this.AdditionField8 = result.AdditionField8;
      this.AdditionField9 = result.AdditionField9;
      this.AdditionField10 = result.AdditionField10;

      this.isCardsTransactionDetails = false;
      this.isNbsTransactionDetails = false;
      this.isUPITransactionDetails = true;
      this.isWalletTransactionDetails = false;
      this.isACHTransactionDetails = false;


    }
    else if (this.PaymentType == 'CreditCard' || this.PaymentType == 'DebitCard' || this.PaymentType == 'PrepaidCard') {
      this.NameonCard = result.NameonCard;       //card values
      this.AccountNo = result.AccountNo;
      this.ExpiryDate = result.ExpiryDate.slice(0, 2) + '/' + 20 + result.ExpiryDate.slice(-2);
      this.CvvResponseCode = result.CvvResponseCode;
      this.AvsResponseCode = result.AvsResponseCode;
      this.CardCodeResponseCode = result.CardCodeResponseCode;
      this.CardLevelResultCode = result.CardLevelResultCode;
      this.CardType = result.CardType;
      this.TrackType = result.TrackType;
      this.ProcessorTransactionNo = result.ProcessorTransactionNo;
      this.TraceNo = result.TraceNo;
      this.TransactionSqNo = result.TransactionSqNo;
      this.EncryptionId = result.EncryptionId;
      this.EncryptionSalt = result.EncryptionSalt;

      this.isCardsTransactionDetails = true;
      this.isNbsTransactionDetails = false;
      this.isUPITransactionDetails = false;
      this.isWalletTransactionDetails = false;
      this.isACHTransactionDetails = false;

    }
    else {
      this.isCardsTransactionDetails = false;
      this.isNbsTransactionDetails = false;
      this.isUPITransactionDetails = false;
      this.isWalletTransactionDetails = false;
      this.isACHTransactionDetails = false;
    }

  });
}
  ngOnInit() {
  }

}
